import { catchError, mergeMap, concatMap, map, finalize } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { forkJoin, throwError, of } from 'rxjs';
import AppSettings from '../../app.settings';
import AngularAppModule from '../../app.module';
import Http from '../../http/http';
import Store from '../../state/store';
import * as UserActions from '../user/user.actions';
import * as AppActions from './app.actions';
import errorTemplate from '../../pages/errors/general/error.html';

const isStorageValid = current => {
  const safeParse = value => {
    try {
      return JSON.parse(value || '{}');
    } catch (e) {
      return {};
    }
  };
  const storage = safeParse(sessionStorage.getItem('onei3-state'));
  const { user = {} } = storage;
  const { account = {} } = user;
  return current.id === user.id && current.account.id === account.id;
};

export const initializeApp = action$ => {
  const sources = [
    Http.get('/api/users/me').pipe(catchError(error => throwError(UserActions.requestUserFailed(error)))),
    Http.get('/api/datapoints/descriptors').pipe(
      catchError(error => throwError(UserActions.requestDatapointsDescriptorsFail(error)))
    )
  ];

  // This requires concatMap to work. concatMap will preserve the order of the array above ^^^
  return action$.pipe(
    ofType(AppActions.APP_INITIALIZE),
    concatMap(() => forkJoin(sources)),
    concatMap(([userData, initialDescriptors]) => {
      if (!userData || (userData.features || []).length === 0) {
        return throwError('User has no features');
      }
      if (isStorageValid(userData)) {
        Store.loadFromStorage();
      }

      return of(
        UserActions.requestUserSuccess(userData),
        UserActions.requestDatapointsDescriptorsSuccess(initialDescriptors),
        AppActions.initialized()
      );
    }),
    catchError(error => {
      //type will define what error page to display
      const type = error === 'User has no features' ? '?type=no_features' : '';
      return of(AppActions.logAppError('APP_INITIALIZE', JSON.stringify(error), '/home', `/home/error${type}`));
    })
  );
};

export const AfterAppInitialized = (action$, state$) =>
  action$.pipe(
    ofType(AppActions.APP_INITIALIZED),
    mergeMap(() => {
      AngularAppModule.bootstrap();
      return of(AppActions.appAnalyticsSet(), AppActions.startAngularBootstrap());
    })
  );

export const logAppErrorsThenRedirect = action$ =>
  action$.pipe(
    ofType(AppActions.LOG_ERROR),
    concatMap(action =>
      Http.post('/api/errorlog', {
        cause: action.payload.cause,
        message: action.payload.message,
        type: 'error',
        url: action.payload.url,
        stackTrace: action.payload.stackTrace
      }).pipe(
        map(() => AppActions.logAppErrorSuccess()),
        catchError(() => of(AppActions.logAppErrorfailed())),
        finalize(() => {
          AngularAppModule.removeLoadingScreen();
          document.body.insertAdjacentHTML('beforeend', errorTemplate);
        })
      )
    )
  );
